import Audience from '../components/Audience'

const AudiencePage = () => (
    <Audience />
)


export default AudiencePage
